












import { defineComponent } from '@vue/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import type { RelatedTree } from '~/types/category/RelatedCategory';
import RelatedCategories from '~/components/molecules/Category/RelatedCategories/RelatedCategories.vue';

export default defineComponent({
  name: 'RelatedCategoryTrees',
  components: {
    RelatedCategories,
  },
  props: {
    relatedTrees: {
      type: Array as PropType<RelatedTree[]>,
      default: () => [],
    },
  },
});
